module.exports = __webpack_public_path__ + "assets/img/dingtalk.3ec38d4a.webp";